export { DialogScrollLock } from '../dialog-scroll-lock';
